import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ActivationStart, Router } from '@angular/router';
import { AyudaEventService, AyudaService } from 'ras-ayuda';
import { Subscription, take } from 'rxjs';
import { AppConfigurationService } from '../app-configuration.service';
import { UrlConfigModel } from '../shared/models/start-up-config/initial-config.model';
import { GtmDatalayerUiService } from '../shared/service/ui/gtm-datalayer-ui.service';
import { StartUpConfigUiService } from '../shared/service/ui/start-up-config-ui.service';
import { TrackingUiService } from '../shared/service/ui/tracking-ui.service';
import { Utils } from '../shared/Utils/Utils';
import { AyudaClientService } from './service/ayuda-client.service';
// TODO: investigate this, is related with counter
// declare function SaveTrackerMultiple(counterName: any, productID: any): any;

@Component({
  templateUrl: './customer-journey.component.html'
})
export class CustomerJourneyComponent implements OnInit, OnDestroy {
  public baseImageUrl: string;
  public urlConfigConfig: UrlConfigModel;
  public isLastPage = false;
  public isSegurosUser = false;
  private ayudaChannelSubscription: Subscription;
  private ayudaFormEventSubscription: Subscription;
  private isAyudaDisable = false;

  constructor(
    private appConfigService: AppConfigurationService,
    private ayudaEventService: AyudaEventService,
    private ayudaService: AyudaService,
    private configUiService: StartUpConfigUiService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private trackingUIService: TrackingUiService,
    private gtmDataLayerUiService: GtmDatalayerUiService,
    private ayudaClientService: AyudaClientService,
  ) {
    router.events.subscribe((event: any) => {
      if (event instanceof ActivationStart) {
        this.isLastPage = event.snapshot?.routeConfig?.path === 'Q2';
      }
    });

    this.activatedRoute.fragment.subscribe((fragment) => {
      if (fragment) {
        this.router.navigate([Utils.getBaseRoute(), fragment], {
          skipLocationChange: true,
          queryParamsHandling: 'merge'
        });
      }
    });
  }

  public ngOnInit(): void {
    if (this.appConfigService.getURLConfig?.baseImageUrl) {
      this.baseImageUrl = this.appConfigService.getURLConfig.baseImageUrl;
    }
    this.isSegurosUser = location.hostname.includes('seguros.es') || location.hostname.includes('segurostest.es');
    this.gtmDataLayerUiService.initGtmDatalayer(this.configUiService.sessionInfo$, false).subscribe();

    this.configUiService.deferredConfig$.pipe(take(1)).subscribe(() => {
      this.initializeAyuda();
    });

    this.configUiService.sessionInfo$.subscribe();
    this.trackingUIService.initIpTracking();
  }

  public ngOnDestroy(): void {
    this.ayudaChannelSubscription?.unsubscribe();
    this.ayudaFormEventSubscription?.unsubscribe();
  }

  private alignAyuda(): void {
    try {
      if (window.innerWidth > 768) {
        const helpButton = document.getElementsByClassName('help-button')[0] as HTMLElement;
        if (helpButton instanceof HTMLElement) {
          helpButton.style.left = (window.innerWidth - 1224) / 2 + 'px';
        }
      }
    } catch (e) {}
  }

  private initializeAyuda(): void {
    this.alignAyuda();

    const defSub = this.configUiService.deferredConfig$.subscribe({
      next: (value) => {
        const ayudaSetting = value && value.ayudaSetting;
        this.isAyudaDisable = !ayudaSetting ? false : ayudaSetting.isChatEnabled || ayudaSetting.isTelephoneEnabled || ayudaSetting.isEmailEnabled;

        if (!this.isAyudaDisable) {
          const helpButton = document.getElementsByClassName('help-button')[0] as HTMLElement;
          if (helpButton instanceof HTMLElement) {
            helpButton.style.display = 'none';
          }
        }

        if (!ayudaSetting) {
          return;
        }
        setTimeout(() => {
          this.ayudaService.updateConfig({
            channelVisibility: {
              isChatEnabled: ayudaSetting.isChatEnabled,
              isCMBEnabled: ayudaSetting.isTelephoneEnabled,
              isEmailEnabled: ayudaSetting.isEmailEnabled,
              isWhatAppEnabled: ayudaSetting.isWhatsAppEnabled
            }
          });

          if (defSub) {
            defSub.unsubscribe();
          }
        }, 800);
      }
    });

    this.ayudaChannelSubscription = this.ayudaEventService.channelSelection$.subscribe({
      next: (event) => {
        this.ayudaClientService.handleChannelSelection(event.channel);
      }
    });

    this.ayudaFormEventSubscription = this.ayudaEventService.formSubmitEvent$.subscribe({
      next: (event) => {
        this.ayudaClientService.handleFormRequest(event);
      }
    });
  }
}
